import { z } from "zod";

export const API_VERSION = "v1" as const;
export const MAX_ENTITY_SLUG_LENGTH = 160;

export const apiErrorCodeSchema = z.enum([
  "BAD_REQUEST",
  "INVALID_CURSOR",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "EMAIL_VERIFICATION_REQUIRED",
  "RATE_LIMITED",
  "CONFLICT",
  "NOT_FOUND",
  "INTERNAL_SERVER_ERROR",
]);

export const apiErrorResponseSchema = z.object({
  error: z.object({
    code: apiErrorCodeSchema,
    message: z.string(),
    requestId: z.string(),
  }),
});

export type ApiErrorCode = z.infer<typeof apiErrorCodeSchema>;
export type ApiErrorResponse = z.infer<typeof apiErrorResponseSchema>;
